import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Procedure, ProcedureFormPayload } from '../../types/procedure'

export const procedureService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
  }) {
    const { data } = await apiClient.get<ApiPaginatedResponse<Procedure> | ApiSuccessResponse<Procedure[]>>(
      '/procedures',
      { params },
    )
    return data
  },

  async create(payload: ProcedureFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Procedure>>('/procedures', payload)
    return data
  },

  async update(id: string, payload: ProcedureFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Procedure>>(`/procedures/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/procedures/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Procedure>>(`/procedures/${id}/restore`)
    return data
  },
}
